import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading">
      Loading bookmarks
    </div>
  );
};

export default LoadingSpinner;